export const productDraftSelector = state => state.product.productDraft;
export const categoriesSelector = state => state.product.categories;
export const flexProductsSelector = state => state.product.flexProducts;
export const fixProductsSelector = state => state.product.fixProducts;
export const isDraftExistsSelector = state => state.product.isDraftExists;
export const productErrorSelector = state => state.product.error;
export const productValidationErrorsSelector = state =>
  state.product.productValidationErrors;
export const productDraftValidationErrorsSelector = state =>
  state.product.productDraftValidationErrors;
